import { Heart, Building2 } from "lucide-react";
import { Reveal, SectionTitle, BrandButton } from "@/components/ui-bits";

export default function Contribuir() {
  return (
    <section id="contribuir" data-testid="section-contribuir" className="py-24 sm:py-32 bg-[#F2EDE3]">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Reveal>
          <SectionTitle className="text-center">Cómo contribuir</SectionTitle>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-8">
          <Reveal>
            <div className="h-full bg-white rounded-3xl p-9 border border-[#ece5d6] flex flex-col">
              <div className="h-14 w-14 rounded-full bg-[#C20A78] text-white flex items-center justify-center">
                <Heart size={26} />
              </div>
              <h3 className="mt-6 font-display text-3xl sm:text-4xl text-[#C20A78] uppercase">
                Aporte personal
              </h3>
              <p className="mt-4 text-base sm:text-lg text-[#141414]/85 leading-relaxed flex-grow">
                ¿Quieres contribuir con este proyecto? Súmate con un aporte personal.
              </p>
              <div className="mt-7">
                <BrandButton testid="contribuir-personal-btn" href="https://www.circulo250.com">
                  Quiero sumarme
                </BrandButton>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="h-full bg-white rounded-3xl p-9 border border-[#ece5d6] flex flex-col">
              <div className="h-14 w-14 rounded-full bg-[#C20A78] text-white flex items-center justify-center">
                <Building2 size={26} />
              </div>
              <h3 className="mt-6 font-display text-3xl sm:text-4xl text-[#C20A78] uppercase">
                Empresa privada / auspicios
              </h3>
              <p className="mt-4 text-base sm:text-lg text-[#141414]/85 leading-relaxed flex-grow">
                Súmate como empresa privada. Consulta por nuestros paquetes de
                auspicios.
              </p>
              <div className="mt-7">
                <BrandButton testid="contribuir-empresa-btn" variant="outline" href="https://wa.me/41789222327">
                  Consultar auspicios
                </BrandButton>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
